import React from 'react';
import { TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Brand, Neutrals } from '@/constants/theme';

interface CheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  id?: string;
  testID?: string;
}

export function Checkbox({ checked, onCheckedChange, id, testID }: CheckboxProps) {
  return (
    <TouchableOpacity
      testID={testID}
      onPress={() => onCheckedChange(!checked)}
      style={[styles.checkbox, checked && styles.checkboxChecked]}
      activeOpacity={0.7}
      hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
      pressRetentionOffset={{ top: 12, left: 12, right: 12, bottom: 12 }}
      accessibilityRole="checkbox"
      accessibilityState={{ checked }}
    >
      {checked && (
        <Ionicons name="checkmark" size={15} color={Neutrals.white} />
      )}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  checkbox: {
    width: 24,
    height: 24,
    borderRadius: 6,
    borderWidth: 2,
    borderColor: Brand.accent,
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkboxChecked: {
    backgroundColor: Brand.accent,
    borderColor: Brand.accent,
  },
});
